import { createReducer } from 'redux-act'
import { combineReducers } from 'redux'
import { showShareDialog } from '../actions'

const isShareDialogShow = createReducer({
  [showShareDialog]: (_, payload) => payload
}, false)

export default combineReducers({ isShareDialogShow })




// WEBPACK FOOTER //
// app/javascript/src/reducers/auth.js